<ng-container *ngIf="!isLoading; else loadingTime">
  <ng-container *ngIf="notifications.length > 0; else noData">
    <table class="table table-borderless transparent-head mb-0">
      <thead>
      <tr>
        <th class="text-center">Closed</th>
        <th>ID</th>
        <th>Title</th>
        <th class="text-center">Created Date</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let obj of notifications; let i = index">
        <tr>
          <td class="text-center">
            <app-is-checked [isChecked]="obj.is_closed == 1"></app-is-checked>
          </td>
          <td>
            <ng-container *ngIf="obj.url; else noUrlTmpl">
              <a [href]="obj.url" [title]="obj.notification" target="_blank" class="clickable text-success">
                <span
                  tooltipClass="large-tooltip"
                  placement="right"
                  [ngbTooltip]="tipContent">{{ obj.notification }}</span>
              </a>
            </ng-container>
            <ng-template #noUrlTmpl>
              <span
                tooltipClass="large-tooltip"
                placement="right"
                [ngbTooltip]="tipContent">{{ obj.notification }}</span>
            </ng-template>

            <ng-template #tipContent>
              <div class="text-start">
                <span class="d-block">Notification: {{ obj.notification }}</span>
                <span class="d-block">Tag Names: &nbsp;{{ obj.tags.join(', ') }}</span>
                <span class="d-block mt-2">{{ obj.description }}</span>
                <span *ngIf="obj.repair_report_description" class="mt-2 d-block">{{ obj.repair_report_description }}</span>
              </div>
            </ng-template>
          </td>
          <td>{{ obj.title }}</td>
          <td class="text-center">{{ obj.created_date | niceDate : '.' : true }}</td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </ng-container>
  <ng-template #noData>
    <nz-alert nzType="info" nzMessage="No notifications!" nzCloseable></nz-alert>
  </ng-template>
</ng-container>
<ng-template #loadingTime>
  <div class="position-relative nz-spin-h mt-5">
    <nz-spin [nzTip]="'Loading data...'"></nz-spin>
  </div>
</ng-template>
